import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { HeaderService } from '../header/header.service';
import { Offcanvas } from '../form.offcanvas';
import { ScriptLoader } from '../script-loader';
import { GroupService } from "../groups/groups.service";
import { AppSettings } from "../../config/config";
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { BrandService } from '../brand/brand.service';
declare var $: any;
declare var jquery: any;
declare var d3: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: [
    './../../assets/css/theme-default/bootstrap.css',
    './../../assets/css/theme-default/materialadmin.css',
    './../../assets/css/theme-default/font-awesome.min.css',
    './../../assets/css/theme-default/material-design-iconic-font.min.css',
    /* './../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
    './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
    './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
    './../../_crop/css/style.css',
    './../../_crop/css/style-example.css',
    './dashboard.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DashboardService, LoginService, HeaderService, Offcanvas, ScriptLoader, GroupService]
})

export class DashboardComponent implements OnInit {

  brand = this.brandService.brand;

  constructor(private dashboardservice: DashboardService, private router: Router,
    private loginservice: LoginService, private headerservice: HeaderService, private offcanvas: Offcanvas,
    private scriptLoader: ScriptLoader, private groupservice: GroupService, private translate: TranslateService,
    private brandService: BrandService) {
    this.schoolCountryCode = this.brandService.brand.defaultCountryDialCode || "91";
  }

  public static gAcademicId = 0;
  private langChangeSubscription: any;

  getAuthToken: any;
  getSchoolId: any;

  endDateDatePicker = new Date();
  preLoader = true;
  schoolCurrency = 'INR';
  schoolCountryCode: string;
  public schoolMatrices;
  totalBroadcast;
  totalStudents;
  totalStaffs;
  totalClasses;
  totalRegStudents = 0;
  lengthRegStudentsArray = 0;
  regAverage = 0;
  adminPermissionlist: any
  studentRegistration = [[0, 0]];
  regTickValue = [[0, '']];

  activeStaffAppUser = 0;
  inActiveStaffAppUser = 0;
  activeParentAppUser = 0;
  inActiveParentAppUser = 0;

  recentBroadcast = [];
  isApproved = false;
  isFranchise: any;

  // new one
  admissionByStatus = true;
  paymentHistoryByStatus = true;

  getNewAdmissionListArray = [];
  getDateAdmission = 0;

  noresultadmission = true;
  loaderadmission = true;
  fkFranchiseId: any

  getSchoolStatusListArray = [];
  getschoolStatusDate;
  loaderactivity = true;

  todayDate;
  viewActivityTotalStudent;
  viewActivityAttendence;
  viewActivityFeesCollected = 0;
  viewActivityDiaries;
  viewActivityTeacher1;
  viewActivityTeacher2;
  viewActivityTeacher3;

  getgetClassFeedListArray = [];
  feedCount = false;

  parentAppAndroidVersion;
  staffAppAndroidVersion;
  onlineFeeCollection = [];
  onlineFeeCollectionTable = null;

  getSchoolName;
  getSchoolImage;
  getSchoolState;
  getSchoolLocality;
  accountType;
  onlinePaymentHistory = 'DISABLED';
  permissions: any;
  dataTablesInstances = {};
  schoolActivityDataInCall = false;
  loginMode = '';
  adminType: any;
  viewActivityClassNumber = '';
  viewActivityClassSection = '';
  feesModuleSettingsDetails: any;
  staffName = ''
  // get school info
  getSchoolInfoFromHeader() {
    this.headerservice.schoolInfo(this.getSchoolId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.getSchoolName = data.schoolName;
          this.getSchoolImage = data.schoolImage;
          this.getSchoolState = data.state;
          this.getSchoolLocality = data.locality;
          this.accountType = data.accountType;
        },
        error => {

        }
      );
  }

  navigateTo(path, data) {
    this.router.navigate(['/' + path], { state: { tab: data } });
  }

  // New admission
  admissionByClick(getValue) {
    this.admissionByStatus = getValue;

    if (getValue === true) {
      this.getDateAdmission = 0;
      this.getNewAdmissionList();
    }
    else {
      this.selectClassStatus = true;
      this.selectClassSectionStatus = true;
      this.selectedCategory = null;
      this.selectedClass = null;
      this.selectedSection = null;
      $("#category-id").val("0");
      $("#class-id").val("0");
      $("#section-id").val("0");
    }
    $('.applyPicker').datepicker({ autoclose: true, endDate: new Date() });
  }

  paymentHistoryByClick(getValue) {
    this.paymentHistoryByStatus = getValue;
    setTimeout(() => {
      $('.applyPicker').datepicker({ autoclose: true, endDate: new Date() });
    }, 50);

  }

  getNewAdmissionList() {
    this.loaderadmission = true;
    this.getNewAdmissionListArray = [];
    this.destroyDataTable('new-admission-table');
    if (this.selectedCategory == "0" || this.selectedCategory == 0) {
      this.selectedCategory = null;
    }
    if (this.selectedClass == "0" || this.selectedClass == 0) {
      this.selectedClass = null;
    }
    if (this.selectedSection == "0" || this.selectedSection == 0) {
      this.selectedSection = null;
    }
    let data = {
      schoolId: this.getSchoolId,
      date: this.getDateAdmission,
      categoryId: this.selectedCategory,
      classStdId: this.selectedClass,
      classId: this.selectedSection
    };
    this.dashboardservice.fetchNewAdmissionList(data, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.loaderadmission = false;
          this.noresultadmission = data.newadmissionlist.length === 0;
            for (let i = 0; i < data.newadmissionlist.length; i++) {
              const item = data.newadmissionlist[i];

              const exists = this.getNewAdmissionListArray.some(existingItem => 
                existingItem.studentId === item.studentId
              );

              if (!exists) {
                this.getNewAdmissionListArray.push(item);
              }

              // Re-initialize datatable after the last iteration
              if (i === data.newadmissionlist.length - 1) {
                this.initializeDataTable_export('new-admission-table');
              }
            }
        },
        error =>
          () => {
          }
      );

  }

  // get admission list by date
  viewAdmissionByDate() {
    this.getDateAdmission = $('.getAdmissionDateBy').val();
    this.getNewAdmissionList();
  }


  // get school activity status
  getSchoolActivityStatus() {
    if (!this.schoolActivityDataInCall) {
      this.schoolActivityDataInCall = true;
      this.getTodayDate();

      this.loaderactivity = true;
      this.getSchoolStatusListArray = [];
      this.destroyDataTable('school-activity-table');
      this.dashboardservice.fetchSchoolActivity(this.getschoolStatusDate, this.getAuthToken)
        .subscribe(
          (data: any) => {
            for (let i = 0; i < data.length; i++) {
              this.getSchoolStatusListArray.push(data[i]);
              // check if for loop end, then re initialize datatable
              if (data.length - 1 === i) {
                this.initializeDataTable('school-activity-table');
                this.loaderactivity = false;
              }
            }

          },
          error =>
            () => {
              this.schoolActivityDataInCall = false;
            }
        );
    }
  }

  // get school activity list by date
  viewSchoolActivityByDate() {
    this.getschoolStatusDate = $('.getstatusdate').val();
    this.getSchoolActivityStatus();
    const a = this.getschoolStatusDate.split('/');
    this.getschoolStatusDate = '' + a[0] + '-' + a[1] + '-' + a[2];
  }

  getProperNumber(num) {
    return num < 10 ? '0' + num : num;
  }

  getOnlineFeePayCollection(singleDate) {
    let d;
    let date;
    let endDate;
    if (singleDate) {
      const sD = $('#online_fee_col_st1').val();
      const dr = sD.split('/');
      date = dr[2] + '-' + dr[1] + '-' + dr[0];
      endDate = date;
    } else {
      const s2 = $('#online_fee_col_st2').val();
      const e2 = $('#online_fee_col_end').val();
      if (s2 && e2 && s2 !== '' && e2 !== '') {
        const s2A = s2.split('/');
        const e2A = e2.split('/');
        date = s2A[2] + '-' + s2A[1] + '-' + s2A[0];
        endDate = e2A[2] + '-' + e2A[1] + '-' + e2A[0];
      } else {
        d = new Date();
        date = d.getFullYear() + '-' + this.getProperNumber(d.getMonth()) + '-' + this.getProperNumber(d.getDate());
        endDate = date;
        $('#online_fee_col_st1').val(this.getProperNumber(d.getDate()) + '/' + this.getProperNumber(d.getMonth()) + '/' + d.getFullYear());
      }
    }

    if (this.onlineFeeCollectionTable) {
      this.onlineFeeCollectionTable.destroy();
      this.onlineFeeCollectionTable = null;
    }
    this.dashboardservice.onlineFeeCollectionHistory(date, endDate, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.onlineFeeCollection = data;
          const h = this;
          setTimeout(() => {
            h.applyOnlinePayHistoryTable();
          }, 100);
        },
        error =>
          () => {
          }
      );
  }

  applyOnlinePayHistoryTable() {
    if (this.onlineFeeCollectionTable === null) {
      
        this.translate.get([
          'dataTables.sEmptyTable',
          'dataTables.lengthMenu',
          
        ]).subscribe(translations => {
          this.onlineFeeCollectionTable = $('#onlineFeeCollectionTable').DataTable({
            dom: 'lCfrtip',
            order: [],
            colVis: {
              buttonText: 'Columns',
              overlayFade: 0,
              align: 'right'
            },
            oLanguage: {
              sEmptyTable: translations['dataTables.sEmptyTable']
            },
            language: {
              lengthMenu:  translations['dataTables.lengthMenu'],
              search: '<i class="fa fa-search"></i>',
              paginate: {
                previous: '<i class="fa fa-angle-left"></i>',
                next: '<i class="fa fa-angle-right"></i>'
              }
            }
          });
        });
      
    }
  }

  // view activity detail
  viewActivityDetail(getClassId, classNumber, classDivision, totalStudents, attendence, fessCollected,
    diaries, teacher1, teacher2, teacher3) {
    this.offcanvas.handleOffcanvasOpen('#offcanvas-view-activity');
    const viewActivityClassId = getClassId;
    this.getschoolStatusDate = $('.getstatusdate').val();
    this.viewActivityClassNumber = classNumber;
    this.viewActivityClassSection = classDivision;
    this.viewActivityTotalStudent = totalStudents;
    this.viewActivityAttendence = attendence;
    this.viewActivityFeesCollected = fessCollected;
    this.viewActivityDiaries = diaries;
    this.viewActivityTeacher1 = teacher1;
    this.viewActivityTeacher2 = teacher2;
    this.viewActivityTeacher3 = teacher3;

    this.getTodayDate();

    this.getClassFeed(viewActivityClassId, this.getschoolStatusDate);

  }

  // get feed for class
  getClassFeed(viewActivityClassId, getschoolStatusDate) {
    this.getgetClassFeedListArray = [];

    this.dashboardservice.fetchClassFeed(viewActivityClassId, getschoolStatusDate, this.getAuthToken)
      .subscribe(
        (data: any) => {
          if (data.length === 0) {
            this.feedCount = false;
          } else {
            this.feedCount = true;
            for (const item of data) {
              this.getgetClassFeedListArray.push(item);
            }
          }

        },
        error =>
          () => {
          }
      );
  }
  // get today date
  getTodayDate() {
    const getDateNow = new Date();
    const getMonth = getDateNow.getUTCMonth() + 1;
    const getDay = getDateNow.getUTCDate();
    const getYear = getDateNow.getUTCFullYear();

    this.todayDate = getYear + '/' + getMonth + '/' + getDay;

  }


  /*Data table operation*/
  destroyDataTable(table) {
    $('#' + table).DataTable().destroy();
  }

  initializeDataTable(table) {

      this.translate.get([
        'dataTables.emptyTable',
        'dataTables.search',
        'dataTables.lengthMenu',
        'dataTables.info',
        'dataTables.infoEmpty',
        'dataTables.paginate.next',
        'dataTables.paginate.previous',
      ]).subscribe(translations => {
        const h = this;
        setTimeout(() => {
          $('#' + table).DataTable({
            language: {
              emptyTable: translations['dataTables.emptyTable'],
              search: translations['dataTables.search'],
              lengthMenu: translations['dataTables.lengthMenu'],
              info: translations['dataTables.info'],
              infoEmpty: translations['dataTables.infoEmpty'],
              paginate: {
                next: translations['dataTables.paginate.next'],
                previous: translations['dataTables.paginate.previous']
              }
            },
          });
          if (table === 'school-activity-table') {
            h.schoolActivityDataInCall = false;
          }
          // this.scriptInit();
        }, 100);
      });
 
  }

  initializeDataTable_export(table) {
    
      this.translate.get([
        'dataTables.emptyTable',
        'dataTables.search',
        'dataTables.lengthMenu',
        'dataTables.info',
        'dataTables.infoEmpty',
        'dataTables.paginate.next',
        'dataTables.paginate.previous',
        'dataTables.buttons.copy',
        'dataTables.buttons.excel',
        'dataTables.buttons.csv'
      ]).subscribe(translations => {
        const utilFun = {
          getText() {
            /*var text = 'New admission export sheet '+$("#groups-category option:selected").text();
            if($("#select14").val() !== 0){
              text += '-'+$("#select14 option:selected").text();
            }
            if($("#select15").val() !== 0){
              text += '-'+$("#select15 option:selected").text();
            }*/
            return 'Admissions';
          }
        };
        const h = this;
        setTimeout(() => {
          $('#' + table).DataTable({
            processing: true,
            destroy: true,
            language: {
              emptyTable: translations['dataTables.emptyTable'],
              search: translations['dataTables.search'],
              lengthMenu: translations['dataTables.lengthMenu'],
              info: translations['dataTables.info'],
              infoEmpty: translations['dataTables.infoEmpty'],
              paginate: {
                next: translations['dataTables.paginate.next'],
                previous: translations['dataTables.paginate.previous']
              }
            },
            dom: 'lfBrtip',
            buttons: [
              // {
              //   extend: 'pdfHtml5',
              //   title: utilFun.getText()
              // },
              {
                extend: 'copyHtml5',
                title: utilFun.getText(),
                text: translations['dataTables.buttons.copy']
              },
              {
                extend: 'excelHtml5',
                title: utilFun.getText(),
                text: translations['dataTables.buttons.excel']
              },
              {
                extend: 'csvHtml5',
                title: utilFun.getText(),
                text: translations['dataTables.buttons.csv']
              }
            ],
          });
          if (table === 'school-activity-table') {
            h.schoolActivityDataInCall = false;
          }
          // this.scriptInit();
        }, 100);
      });
   
  }

  getDashboardData() {
    this.dashboardservice.fetchDashboardData(this.getSchoolId, DashboardComponent.gAcademicId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          // init script
          this.initScripts();
          setTimeout(() => this.initScripts(), 500);
          /*///////////////////////////////////////////*/
          // matrices data
          this.totalBroadcast = data.dashboardMetrices.totalBroadcast.toLocaleString('en');
          this.totalStudents = data.dashboardMetrices.totalStudent.toLocaleString('en');
          this.totalStaffs = data.dashboardMetrices.totalStaff.toLocaleString('en');
          this.totalClasses = data.dashboardMetrices.totalClass.toLocaleString('en');
          /*//////////////////////////////*/


          // people status
          this.activeStaffAppUser = data.dashboardMetrices.ActiveStaffAppUser.toLocaleString('en');
          this.inActiveStaffAppUser = data.dashboardMetrices.InActiveStaffAppUser.toLocaleString('en');
          this.activeParentAppUser = data.dashboardMetrices.ActiveParentAppUser.toLocaleString('en');
          this.inActiveParentAppUser = data.dashboardMetrices.InActiveParentAppUser.toLocaleString('en');
          /*//////////////////////////*/

          this.parentAppAndroidVersion = data.dashboardMetrices.AndroidParentAppVersion;
          this.staffAppAndroidVersion = data.dashboardMetrices.AndroidStaffAppVersion;

          // recent broadcast
          for (let i = 0; i < data.recentBroadcast.length; i++) {
            let message = decodeURIComponent(data.recentBroadcast[i].message);
            message = this.getWords(message, 5) + '.....';
            const createdTime = data.recentBroadcast[i].createdTime;
            const createdBy = data.recentBroadcast[i].createdBy;
            const approvedStatus = data.recentBroadcast[i].approvedStatus;
            if (approvedStatus === 0) {
              this.isApproved = false;
            } else if (approvedStatus === 1) {
              this.isApproved = true;
            }
            data.recentBroadcast[i] = {
              message,
              createdTime,
              createdBy,
              approvedStatus: this.isApproved
            };
            this.recentBroadcast.push(data.recentBroadcast[i]);
          }
          /*//////////////////////////////////////////////*/


          // registarion graph
          this.lengthRegStudentsArray = data.studentRegistration.length;
          this.totalRegStudents = this.totalStudents;
          for (let i = 0; i < this.lengthRegStudentsArray; i++) {
            if (data.studentRegistration[i].year !== 0 && data.studentRegistration[i].year !== null) {
              const coord1 = [];
              coord1.push(i + 1);
              coord1.push(data.studentRegistration[i].numberofstudents);

              const coord2 = [];
              coord2.push(i + 1);
              coord2.push(data.studentRegistration[i].year);

              this.studentRegistration.push(coord1);
              this.regTickValue.push(coord2);
            }
          }

          const a = data.studentRegistration[0].numberofstudents;
          const b = this.totalRegStudents - a;

          if (a > b) {
            this.regAverage = (b / a) * 100;
          } else if (a < b) {
            this.regAverage = (a / b) * 100;
          }
          this.regAverage = parseFloat(this.regAverage.toFixed(2));

          // get academic Id
          this.getAcademicData();
        },
        error =>
          () => {
          }
      );
  }

  // get academic details
  getAcademicData() {
    this.dashboardservice.fetchAcademicList(this.getSchoolId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          for (const item of data.academicList) {
            if (item.InActive === 0) {
              DashboardComponent.gAcademicId = item.pkAcademicId;
            }
          }
        },
        error => {
        }
      );
  }


  // string wrap to words function
  getWords(str, count) {
    return str.split(/\s+/).slice(0, count).join(' ');
  }

  // getWords(str,5);


  // // token auth
  // isStaffLoginValidToken() {
  //   let isValidToken = false;
  //   let isValidSchool = 0;
  //   this.loginservice.isValidToken(this.getAuthToken)
  //     .subscribe(
  //       (data: any) => {
  //         isValidToken = data.isValid;
  //         console.log("isValidToken", isValidToken);
  //         if (data.errorcode === 10010) {
  //           this.router.navigate(['/suspended']);
  //         } else if (isValidToken === true) {

  //           this.loginservice.isValidSchoolId(this.getSchoolId)
  //             .subscribe(
  //               (validData: any) => {
  //                 isValidSchool = validData.schoolExist;
  //                 if (isValidSchool !== 1) {
  //                   this.router.navigate(['/login']);
  //                 }
  //                 else {
  //                   if (this.loginMode === 'STAFF') {
  //                     this.router.navigate(['/exams']);
  //                   }
  //                   else {
  //                     console.log("Success");

  //                     this.getDashboardData();
  //                     this.getSchoolInfoFromHeader();
  //                     this.getNewAdmissionList();
  //                     this.getGroupsClassCategories(this.getSchoolId);
  //                     //this.initDataTableServerProcess("new-admission-table-2", this.getSchoolId, this.getAuthToken, null, null, null, null)
  //                   }
  //                 }
  //               },
  //               error => {
  //               }
  //             );
  //         } else {
  //           this.router.navigate(['/login']);
  //         }
  //       },
  //       error => {
  //       }
  //     );
  // }


  // token auth
  isValidToken() {
    console.log("DASHBOARD",this.staffName);
    
    if (this.getAuthToken && this.getSchoolId) {
      localStorage.setItem('usertoken', this.getAuthToken);
      localStorage.setItem('schoolinfo', this.getSchoolId);
      localStorage.setItem('loginMode', this.loginMode);
      localStorage.setItem('adminType', this.adminType);
      localStorage.setItem('feesModuleSettings', this.feesModuleSettingsDetails);
      localStorage.setItem('currency', this.schoolCurrency);
      localStorage.setItem('isFranchise', this.isFranchise);
      localStorage.setItem('fkFranchiseId', this.fkFranchiseId);
      localStorage.setItem('adminPermissionlist', this.adminPermissionlist);
      localStorage.setItem("staffName", this.staffName);
      this.schoolCountryCode = this.schoolCountryCode.startsWith('+') ? this.schoolCountryCode.slice(1) : this.schoolCountryCode;
      localStorage.setItem("countryCode", this.schoolCountryCode)
      this.getDashboardData();
      this.getSchoolInfoFromHeader();
      this.getNewAdmissionList();
      this.getGroupsClassCategories(this.getSchoolId);
    } else if(this.loginMode === "STAFF"){
      const staffName = localStorage.getItem('staffName')
      console.log("staffName",staffName,this.staffName);
      
      this.router.navigate(["/exams"]);
    }else {
      this.router.navigate(['/login']);
    }
  }

  initScripts() {
    this.scriptLoader.loadScript($, 'DASHBOARD');
  }
  ngOnInit() {
    const tokenCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith('usertoken='));
    let tokenValue = tokenCookie ? tokenCookie.split('=')[1] : null;
    this.getAuthToken = tokenValue;
    const getSchoolIdDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('schoolinfo='));
    let getSchoolIdDetailsValue = getSchoolIdDetails ? getSchoolIdDetails.split('=')[1] : null;
    this.getSchoolId = getSchoolIdDetailsValue
    const loginModeDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('loginMode='));
    let loginModeDetailsValue = loginModeDetails ? loginModeDetails.split('=')[1] : null;
    this.loginMode = loginModeDetailsValue;
    const adminTypeDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('adminType='));
    let adminTypeDetailsValue = adminTypeDetails ? adminTypeDetails.split('=')[1] : null;
    this.adminType = adminTypeDetailsValue;

    const schoolCurrencyDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('currency=')) || 'INR';
    let schoolCurrencyDetailsValue = schoolCurrencyDetails ? schoolCurrencyDetails.split('=')[1] : null;
    this.schoolCurrency = schoolCurrencyDetailsValue;

    const schoolCountryCodeDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('countryCode=')) || this.brandService.brand.defaultCountryDialCode || '91';
    let schoolCountryCodeDetailsValue = schoolCountryCodeDetails ? schoolCountryCodeDetails.split('=')[1] : null;
    this.schoolCountryCode = schoolCountryCodeDetailsValue;

    const isFranchiseDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('isFranchise='));
    let isFranchiseValue = isFranchiseDetails ? isFranchiseDetails.split('=')[1] : null;
    this.isFranchise = isFranchiseValue;

    const fkFranchiseIdDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('fkFranchiseId='));
    let fkFranchiseIdValue = fkFranchiseIdDetails ? fkFranchiseIdDetails.split('=')[1] : null;
    this.fkFranchiseId = fkFranchiseIdValue;
    const loginStaffName = document.cookie.split(';').find(cookie => cookie.trim().startsWith('staffName='));
    let staffNameValue = loginStaffName ? loginStaffName.split('=')[1] : null;
    this.staffName = staffNameValue;
    console.log("loginStaffName:",loginStaffName,staffNameValue,this.staffName);
    
    if (this.loginMode === 'STAFF') {
      this.router.navigate(['/exams']);
    }
    const adminPermissionlistDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('adminPermissionlist='));
    const adminPermissionlist = adminPermissionlistDetails ? adminPermissionlistDetails.split('=')[1] : null;
    this.adminPermissionlist = adminPermissionlist

    if (adminPermissionlist) {
      const list = JSON.parse(adminPermissionlist);
      this.permissions = list;
    }
    let feesModuleSettings = [{ isFeesModuleEnable: '', SettingName: '' }];
    const feesModuleSettingsStoreDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('feesModuleSettings='));
    const feesModuleSettingsStore = feesModuleSettingsStoreDetails ? feesModuleSettingsStoreDetails.split('=')[1] : null;
    this.feesModuleSettingsDetails = feesModuleSettingsStore;
    if (feesModuleSettingsStore) {
      feesModuleSettings = JSON.parse(feesModuleSettingsStore);
      if (feesModuleSettings.length > 0) {
        let isOnlinePayEnabled = false;
        let isIndependentFeeEnabled = false;
        for (const setting of feesModuleSettings) {
          if (setting.isFeesModuleEnable === 'ENABLED' && setting.SettingName === 'ONLINE_PAYMENT_INDEPENDENT_TO_FEES_STRUCTURE') {
            isIndependentFeeEnabled = true;
          }
          if (setting.isFeesModuleEnable === 'ENABLED' && setting.SettingName === 'MOBILE_FEES_PAYMENT') {
            isOnlinePayEnabled = true;
          }
        }
        if (isIndependentFeeEnabled && isOnlinePayEnabled) {
          this.onlinePaymentHistory = 'ENABLED';
        } else {
          this.onlinePaymentHistory = 'DISABLED';
        }
      }
    }
    const h = this;
    $('#load_new_admissions').on('click', () => {
      h.getNewAdmissionList();
    });

    this.isValidToken();

    setTimeout(() => this.initScripts(), 500);

    this.getNewAdmissionList();
    this.getSchoolActivityStatus();
    
    this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.getNewAdmissionList();
      this.getSchoolActivityStatus();
    });
  }

  ngOnDestroy(): void {
        if (this.langChangeSubscription) {
            this.langChangeSubscription.unsubscribe();
        }
    }

  schoolCategories = [];
  selectedCategory = null;
  selectedSection = null;
  schoolClasses = [];
  selectClassStatus = true;
  schoolClassesSections = [];
  selectClassSectionStatus = true;
  selectedClass = null;
  studentListTable: any;



  getGroupsClassCategories(schoolId) {
    this.schoolCategories = [];
    this.groupservice.groupsClassCategories(schoolId, this.getAuthToken)
      .subscribe(
        (data: any) => {

          for (let i = 0; i < data.schoolCategory.length; i++) {
            this.schoolCategories.push(data.schoolCategory[i]);

            if (data.schoolCategory.length - 1 === i && this.schoolCategories.length !== 0) {
              //this.initializeCategoryData(0);

            }

          }
        },
        error => {
        }
      );
  }

  getCategoryFunction(selectedCategoryId) {
    this.schoolClasses = [];
    this.schoolClassesSections = [];
    this.selectClassStatus = selectedCategoryId == 0;
    this.selectClassSectionStatus = true;
    this.selectedCategory = selectedCategoryId;
    this.selectedClass = null;
    this.selectedSection = null;
    this.getNewAdmissionList();
    if (selectedCategoryId != 0) {
      this.groupservice.groupsAvailableClass(this.getSchoolId, this.selectedCategory, this.getAuthToken)
        .subscribe(
          (data: any) => {
            for (const item of data.className) {
              this.schoolClasses.push(item);
            }
          },
          error => { }
        );
    }
  }

  selectClassFunction(selectedClassId) {
    this.selectedClass = selectedClassId;
    this.selectedSection = null;
    this.schoolClassesSections = [];
    this.selectClassSectionStatus = selectedClassId == 0;
    this.selectedSection = null;
    this.getNewAdmissionList();
    if (selectedClassId != 0) {
      this.groupservice.groupsAvailableClassSection(this.selectedClass, this.getAuthToken)
        .subscribe(
          (data: any) => {
            for (const item of data) {
              this.schoolClassesSections.push(item);
            }
          },
          error => { }
        );
    }
  }

  selectSectionFunction(selectedSectionId) {
    this.selectedSection = selectedSectionId;
    this.getNewAdmissionList();
  }

}